export default "__VITE_ASSET__B4x8LX6Z__"